import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const competitionApi = generateNomenApi(`/nomen/competitions`);

export const competitionOptions = generateNomenOptions('competition', competitionApi);
